import { useState } from "react";
import { Popover } from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import CheckIcon from "@mui/icons-material/Check";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export const SORT_OPTIONS = [
  { key: "completionRate", labelKey: "manage_stats_table_completion" },
  { key: "daysActiveCount", labelKey: "manage_stats_table_active_days" },
  { key: "perfectDaysCount", labelKey: "manage_stats_table_perfect_days" },
  { key: "member", labelKey: "manage_stats_table_member" },
];

/** Üye listesinin sıralama seçici; tarih filtresiyle aynı dilde. */
export default function ProgressSortButton({ value, onChange }) {
  const { t } = useScriptMode();
  const [anchor, setAnchor] = useState(null);
  const current = SORT_OPTIONS.find((o) => o.key === value) || SORT_OPTIONS[0];

  return (
    <>
      <button
        type="button"
        data-sort-trigger
        onClick={(e) => setAnchor(e.currentTarget)}
        className="inline-flex items-center gap-2.5 h-10 pl-3 pr-4 rounded-xl border border-terakkiBorder bg-terakkiSurface hover:border-terakkiPrimary transition-colors dark:bg-white/[0.06] dark:border-white/[0.14] dark:hover:border-white/30"
      >
        <SwapVertIcon fontSize="small" className="text-terakkiPrimaryDark dark:text-[#8FC9CA]" aria-hidden />
        <span className="flex flex-col items-start leading-tight">
          <span className="text-[10px] uppercase tracking-wide text-terakkiNeutral dark:text-white/70">
            {t("manage_stats_sort_label")}
          </span>
          <span className="text-sm font-SemiBold text-terakkiInk dark:text-white">{t(current.labelKey)}</span>
        </span>
      </button>

      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{ paper: { sx: { borderRadius: 3, mt: 1, width: 240 } } }}
      >
        <ul className="p-2 flex flex-col">
          {SORT_OPTIONS.map((option) => {
            const active = option.key === value;
            return (
              <li key={option.key}>
                <button
                  type="button"
                  data-sort={option.key}
                  aria-pressed={active}
                  onClick={() => {
                    onChange(option.key);
                    setAnchor(null);
                  }}
                  className={[
                    "w-full flex items-center justify-between gap-2 px-3 py-2.5 rounded-lg text-sm text-left transition-colors",
                    active
                      ? "bg-terakkiBrandCloud text-terakkiPrimaryDark font-SemiBold dark:bg-white/10 dark:text-[#8FC9CA]"
                      : "text-terakkiInk hover:bg-terakkiSurfaceAlt dark:text-white dark:hover:bg-white/5",
                  ].join(" ")}
                >
                  {t(option.labelKey)}
                  {active && <CheckIcon sx={{ fontSize: 16 }} aria-hidden />}
                </button>
              </li>
            );
          })}
        </ul>
      </Popover>
    </>
  );
}
